import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ClientInput } from "../inputs/ClientInput";
import { clientEntriesSelector } from "../../store/selectors/clientEntries";
import { operationsSelector } from "../../store/selectors/entities/operations";
import { interactiveClientSelector } from "../../store/selectors/clientSettings";
import { calculate, formatValue } from "../../lib/fields/Calculation/helpers";
export const CalculationPreview = ({
  guid,
  label,
  id,
  value,
  parentGuid = guid,
  rowGuid = '',
  update,
  mask = 0,
  style = 0
}) => {
  const interactiveClient = useSelector(interactiveClientSelector);
  const clientEntries = useSelector(clientEntriesSelector);
  const operations = useSelector(operationsSelector);
  const entryOperations = operations.filter(({
    entry
  }) => entry === parentGuid);
  const entries = clientEntries.filter(entry => {
    if (rowGuid) {
      const inOperation = entryOperations.filter(operation => operation.entry === parentGuid && operation.parentEntryGuid === entry.guid);
      return inOperation.length > 0 || entry.rowGuid === rowGuid;
    }
    return entry;
  });
  const calculation = interactiveClient ? calculate(entries, entryOperations, style) : 0;
  const formattedValue = formatValue(calculation, style, mask);
  useEffect(() => {
    update(formattedValue);
  }, [calculation, mask]);
  const numberProps = {
    value: formattedValue,
    readOnly: true,
    disabled: true,
    label: label,
    id
  };
  return <ClientInput {...numberProps} />;
};